import { mapChangelogOutDtoToModel } from 'shared/domain/changelog/mapping';
import { issueClient } from 'shared/domain/issue/issueClient';
import type { IssueChangelogMapped } from './types';

export async function fetchIssueChangelogMapped(
  issueId: string
): Promise<IssueChangelogMapped> {
  return mapChangelogOutDtoToModel(await issueClient.getChangelog(issueId));
}
